<template>
  <div  :class="['fixed-menu', (open ? 'active' : '')]">
    <div :class="['menu', 'mobile', (open ? 'scroll' : '')]">
      <ul class="menu-list">
        <li v-for="(item, key) in menu" @click="menuclick(item)">
          <div :class="['bg', 'bg-menu-' + key]"></div>
          <span class="text">{{ item.title }}</span>
        </li>
      </ul>
      <div class="copyright">
        <div class="year"><span>© 2018</span> GNation Alliance</div>
        <a href="https://www.gn.org">www.gn.org</a>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: [
    'active',
    'menu'
  ],

  data () {
    return {
      open: this.active
    }
  },

  methods: {
    menuclick (item) {
      this.$emit('menuclick', item)
    }
  },

  watch: {
    active (val) {
      this.open = val
    }
  }
}
</script>

<style lang="scss">
.fixed-menu {
  position: fixed;
  right: 0px;
  bottom: 0px;
  top: 0px;
  width: 0vw;
  overflow: hidden;
  transition: all .8s cubic-bezier(.19,1,.22,1);
  background-color: rgba(3, 78, 178, 0.7);
  clip: rect(auto,auto,auto,auto);
  &.active {
    width: 100vw;
    .menu-list {
      li {
        span {
          opacity: 1;
        }
      }
    }
  }
}

.menu {
  width: 100vw;
  height: 100vh;
  position: absolute;
  bottom: 0;
  right: 0;
  top: 0;
  &.mobile {
    @media (max-height: 1025px) and (max-width: 769px) {
      .menu-list {
        height: 550px;
      }
    }

    @media (max-height: 600px) and (max-width: 1018px) {
      overflow-y: scroll;
      .menu-list {
        position: static;
        margin-top: 0px;
        padding-top: 100px;
        padding-bottom: 30px;
        margin-bottom: 65px;
        padding-right: 0px;
      }

      .menu-list {
        li {
         height: auto;
          span {
            // white-space: nowrap;
            padding-right: 25px;
            width: 100%;
            display: block;
          }
        }
      }
    }
  }

  .menu-list {
    display: flex;
    position: fixed;
    left: 0px;
    right: 100px;
    top: 0px;
    bottom: 0px;
    li {
      position: relative;
      .bg {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        opacity: 0;
        transition: all .6s ease;
      }
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      cursor: pointer;
      height: 100%;
      text-align: center;
      font-weight: bold;
      overflow: hidden;
      border-right: 1px solid #2F80ED;
      span {
        opacity: 0;
        pointer-events: none;
        transition: all 1s ease;
        transform: translateX(10px);
      }
      &:last-child {
        border-right: 0px;
      }
      &:hover {
        .bg {
          opacity: 1;
        }
        span {
          transform: translateX(0px);
        }
      }
    }
  }

  .copyright {
    position: absolute;
    bottom: 30px;
    left: 0px;
    right: 0px;
    width: 188px;
    margin: auto;
    text-align: right;
    color: white;
    opacity: 0.6;
    z-index: 10;
    a {
      color: white;
      text-decoration: none;
    }
    @media (max-width: 1018px) {
      left: 20px;
      bottom: 20px;
      margin: 0; 
    }
    .year {
      color: rgba(255, 255, 255, 0.5);;
    }
    span {
      margin-right: 10px;
    }
  }
}
</style>